import { render, staticRenderFns } from "./customSkillsTab.vue?vue&type=template&id=3da6ff86&scoped=true&"
import script from "./customSkillsTab.vue?vue&type=script&lang=js&"
export * from "./customSkillsTab.vue?vue&type=script&lang=js&"
import style0 from "./customSkillsTab.vue?vue&type=style&index=0&id=3da6ff86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6ff86",
  null
  
)

export default component.exports